import { ChangeDetectionStrategy, Component, OnInit, input, computed } from '@angular/core';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { PluralPipe } from '@bazis/shared/pipes/plural.pipe';
import { CommonModule } from '@angular/common';
import { LocalDatePipe } from '@bazis/shared/pipes/local-date.pipe';
import { TranslocoModule } from '@jsverse/transloco';
import { SizeRange } from '@bazis/shared/models/base.types';

@Component({
    selector: 'bazis-dateplate',
    templateUrl: './dateplate.component.html',
    imports: [IconModule, PluralPipe, CommonModule, LocalDatePipe, TranslocoModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateplateComponent implements OnInit {
    readonly titleKey = input<string>();

    readonly titleParams = input<any>();

    readonly count = input<number>();

    readonly date = input<string>();

    readonly time = input<string>();

    readonly timeStart = input<string>();

    readonly timeEnd = input<string>();

    readonly hideTime = input<boolean>(false);

    readonly size = input<SizeRange>(SizeRange.compact);
    //                       mini  compact regular large huge  giant
    // readonly size = input<'xxs' | 'xs' | 's' | 'md' | 'l' | 'xl'>('xs');

    readonly calculatedTime = computed(() => {
        if (this.time()) {
            return this.getHoursAndMinutes(this.time());
        }
        return null;
    });

    readonly calculatedTimeStart = computed(() => {
        if (this.timeStart()) {
            return this.getHoursAndMinutes(this.timeStart());
        }
        return null;
    });

    readonly calculatedTimeEnd = computed(() => {
        if (this.timeEnd()) {
            return this.getHoursAndMinutes(this.timeEnd());
        }
        return null;
    });

    ngOnInit(): void {}

    // не понятно зачем преобразование в тот же формат что и получаем? возможны секунды?
    getHoursAndMinutes(time: string): string {
        const hours = time.slice(0, 2);
        const minutes = time.slice(3, 5);

        return hours + ':' + minutes;
    }
}
